/**
 * OAuth Constants and Configuration
 * Centralized constants for OAuth state handling
 */

export const OAUTH_STATE_KEYS = {
  WL_ID: 'wlId',
  ORIGIN: 'origin',
  SURVEY_TOKEN: 'surveyAfterEventToken',
  ALLOWED_GROUPS: 'allowedGroups',
  STRIPE_DEEP_LINK: 'stripeDeepLink',
} as const;

export const OAUTH_ERRORS = {
  INVALID_STATE: 'Invalid OAuth state parameter',
  DECODE_FAILED: 'Failed to decode state parameter',
  PARSE_FAILED: 'Failed to parse OAuth state',
  MISSING_PROVIDER: 'OAuth provider not specified',
} as const;

/**
 * Safe base64 encoding with error handling
 * Always removes padding for OAuth compatibility
 */
export const safeBase64Encode = (data: string): string => {
  try {
    const encoded = btoa(data);
    // Remove padding for consistent OAuth provider compatibility
    return encoded.replace(/=+$/, '');
  } catch (error) {
    console.warn('[OAuth] Base64 encoding failed:', error);
    return '';
  }
};

/**
 * Safe base64 decoding with error handling
 */
export const safeBase64Decode = (data: string): string | null => {
  try {
    return atob(data);
  } catch (error) {
    console.warn('[OAuth] Base64 decoding failed:', error);
    return null;
  }
};
